import { styled, css } from 'styled-components'
import { onLargeScreen } from 'mixtiles-web-common'

export const Container = styled.div<{ $sticky?: boolean }>`
  border-bottom: 1px solid ${(props) => props.theme.colors.grayMedium};
  z-index: 2;
  background: ${(props) => props.theme.colors.grayBackgroundWhite};

  ${({ $sticky }) =>
    $sticky &&
    css`
      position: sticky;
      top: 0;
    `}
`

export const MenuStrip = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding-right: 12px;
  padding-left: 12px;
  position: relative;

  ${onLargeScreen()} {
    height: 72px;
    padding-right: 25px;
    padding-left: 25px;
  }
`

export const ButtonContainer = styled.div`
  min-width: 32px;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.black};
  position: absolute;
  white-space: nowrap;
  width: 100%;
  text-align: center;
  left: 0;
  pointer-events: none;
`
